import { API } from "../../utils/http";

function toApiError(e) {
	if (e?.code === "ERR_NETWORK") return { message: "Network error" };
	return e?.response?.data?.error || { message: e?.message || "Unexpected error" };
}

export function listBulkPaymentsApi() {
	return API.get("bulk-payments")
		.then((r) => r.data)
		.catch((e) => Promise.reject(toApiError(e)));
}

export function getBulkPaymentApi(batchId) {
	return API.get(`bulk-payments/${batchId}`)
		.then((r) => r.data)
		.catch((e) => Promise.reject(toApiError(e)));
}

export function getBulkPaymentFileApi(batchId) {
	return API.get(`bulk-payments/${batchId}/file`)
		.then((r) => r.data)
		.catch((e) => Promise.reject(toApiError(e)));
}

export function deleteBulkPaymentApi(batchId) {
	return API.delete(`bulk-payments/${batchId}`)
		.then((r) => r.data)
		.catch((e) => Promise.reject(toApiError(e)));
}

export function generateBulkPaymentApi(request) {
	return API.post("bulk-payments", request)
		.then((r) => r.data)
		.catch((e) => Promise.reject(toApiError(e)));
}
